var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [{ title: _vm.$t("billing.invoiceManagement") }],
          select: true,
          showChatbotSession: true,
        },
      }),
      _vm._v(" "),
      _vm.updatingCard
        ? _c("UpdateCardModal", {
            on: {
              cancel: function ($event) {
                _vm.updatingCard = false
              },
              create: _vm.updateCard,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.updatingBilling
        ? _c("UpdateBillingModal", {
            on: {
              cancel: function ($event) {
                _vm.updatingBilling = false
              },
              create: _vm.updateBilling,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.trialSkipModal
        ? _c("TrialSkipModal", {
            on: {
              reject: function ($event) {
                _vm.trialSkipModal = false
              },
              confirm: _vm.skipTrial,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.billModal
        ? _c("CreateInvoiceModal", {
            on: {
              cancel: function ($event) {
                _vm.billModal = false
              },
              create: _vm.createInvoice,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "billing" } }, [
        _vm.trialInfo.remainingDays > 0
          ? _c("div", { staticClass: "trial-information" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "skip-now",
                  on: {
                    click: function ($event) {
                      _vm.trialSkipModal = true
                    },
                  },
                },
                [_vm._v("Hemen Atla")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.shouldSelectPlan.enabled
          ? _c("div", { staticClass: "trial-information absolute-top" }, [
              _c("span", { staticClass: "material-icons alert-icon" }, [
                _vm._v("notification_important"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "information" }, [
                _c("div", { staticClass: "information-message" }, [
                  _vm._v(
                    "\n                    Şuan sistem tarafından paketleriniz koşulları sağlanmadığı için sınırlandırıldınız.\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "information-details" }, [
                  _vm.shouldSelectPlan.supsisPackage
                    ? _c("div", { staticClass: "information-detail" }, [
                        _c("div", { staticClass: "information-detail-text" }, [
                          _vm._v("\n                            - Toplam "),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.shouldSelectPlan.details.current.users)
                            ),
                          ]),
                          _vm._v(
                            " Adet Temsilciniz\n                            bulunmaktadır.\n                            "
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.shouldSelectPlan.details.current.users -
                                  _vm.shouldSelectPlan.details.limit
                                    .currentSupsisAgentCount
                              )
                            ),
                          ]),
                          _vm._v(
                            "\n                            Adet Temsilcinizi devre dışı bırakınız veya siliniz veya temsilci satın alınız.\n                        "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shouldSelectPlan.whatsappQr
                    ? _c("div", { staticClass: "information-detail" }, [
                        _c("div", { staticClass: "information-detail-text" }, [
                          _vm._v("\n                            - Toplam "),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.shouldSelectPlan.details.current.whatsappQr
                              )
                            ),
                          ]),
                          _vm._v(
                            " Adet Whatsapp QR\n                            kanalınız bulunmaktadır.\n                            "
                          ),
                          _c("b", [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.shouldSelectPlan.details.current
                                    .whatsappQr -
                                    _vm.shouldSelectPlan.details.limit
                                      .currentWhatsappPlanCount
                                )
                            ),
                          ]),
                          _vm._v(
                            "\n                            Adet Whatsapp QR kanalınızı siliniz veya kanal satın alınız.\n                        "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shouldSelectPlan.whatsappBusiness
                    ? _c("div", { staticClass: "information-detail" }, [
                        _c("div", { staticClass: "information-detail-text" }, [
                          _vm._v("\n                            - Toplam "),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.shouldSelectPlan.details.current
                                  .whatsappBusinessChannels
                              )
                            ),
                          ]),
                          _vm._v(
                            " Adet\n                            Whatsapp Business kanalınız bulunmaktadır.\n                            "
                          ),
                          _c("b", [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.shouldSelectPlan.details.current
                                    .whatsappBusinessChannels -
                                    _vm.shouldSelectPlan.details.limit
                                      .currentWhatsappBusinessChannelCount
                                )
                            ),
                          ]),
                          _vm._v(
                            "\n                            Adet Whatsapp Business kanalınızı siliniz veya kanal satın alınız.\n                        "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "billing-section" }, [
          _c(
            "div",
            {
              staticClass: "title-head",
              on: {
                click: function ($event) {
                  return _vm.toggleCollopes("currentPlan")
                },
              },
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("Mevcut Paketler")]),
              _vm._v(" "),
              _c("div", { staticClass: "collopse" }, [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.collopes["currentPlan"]
                          ? "arrow_right"
                          : "arrow_drop_down"
                      ) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content",
              class: { closed: _vm.collopes["currentPlan"] },
            },
            [
              _c("CurrentPlans", {
                class: "current-plans",
                on: { show: _vm.showPlans },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "billing-section" }, [
          _c(
            "div",
            {
              staticClass: "title-head",
              on: {
                click: function ($event) {
                  return _vm.toggleCollopes("additional")
                },
              },
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("Ek Paketler")]),
              _vm._v(" "),
              _c("div", { staticClass: "collopse" }, [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.collopes["additional"]
                          ? "arrow_right"
                          : "arrow_drop_down"
                      ) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content",
              class: { closed: _vm.collopes["additional"] },
            },
            [_c("Features", { class: "feature-items" })],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "billing-section" }, [
          _c(
            "div",
            {
              staticClass: "title-head",
              on: {
                click: function ($event) {
                  return _vm.toggleCollopes("invoiceDetail")
                },
              },
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("Fatura Bilgileri")]),
              _vm._v(" "),
              _c("div", { staticClass: "collopse" }, [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.collopes["invoiceDetail"]
                          ? "arrow_right"
                          : "arrow_drop_down"
                      ) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content",
              class: { closed: _vm.collopes["invoiceDetail"] },
            },
            [
              _c("div", { staticClass: "invoice-details" }, [
                _c("div", { staticClass: "billing-section" }, [
                  _c(
                    "div",
                    { staticClass: "content", staticStyle: { width: "100%" } },
                    [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("message.billingAddress"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "bills-content" }, [
                          _c("div", { staticClass: "bills" }, [
                            _vm.billingDetail &&
                            _vm.billingDetail.billingAddress
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "bill",
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "top",
                                      "justify-content": "space-between",
                                      padding: "20px 0px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "padding-right": "30px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                    " +
                                                _vm._s(
                                                  _vm.billingDetail
                                                    .billingType == "company"
                                                    ? _vm.billingDetail.name
                                                    : _vm.billingDetail.name +
                                                        " " +
                                                        _vm.billingDetail
                                                          .surname
                                                ) +
                                                "\n                                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                                                    " +
                                              _vm._s(
                                                _vm.billingDetail.billingAddress
                                              ) +
                                              " -\n                                                    " +
                                              _vm._s(
                                                _vm.billingDetail.billingCountry
                                              ) +
                                              "/" +
                                              _vm._s(
                                                _vm.billingDetail.billingCity
                                              ) +
                                              "\n                                                "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "supsis-ghost-button",
                                on: {
                                  click: function ($event) {
                                    _vm.updatingBilling = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "material-icons",
                                    staticStyle: {
                                      "font-size": "16px",
                                      "margin-right": "5px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                edit\n                                            "
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(
                                      _vm.billingDetail &&
                                        _vm.billingDetail.billingAddress
                                        ? _vm.$t("message.edit")
                                        : _vm.$t("message.addNewAddress")
                                    ) +
                                    "\n                                        "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "billing-section",
                    staticStyle: { width: "100%" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        staticStyle: { width: "100%" },
                      },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("billing.paymentMethod")) +
                                "\n                                    "
                            ),
                            _c(
                              "div",
                              { staticClass: "iyzico-pay" },
                              [_c("IyzicoPay")],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "bills-content" }, [
                            _c("div", { staticClass: "bills" }, [
                              _vm.billingDetail && _vm.billingDetail.binNumber
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "bill",
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        "justify-content": "space-between",
                                        padding: "20px 0px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "padding-right": "30px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "top",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "payment-method",
                                                },
                                                [
                                                  _c("DynamicSvg", {
                                                    attrs: {
                                                      name: _vm.formatCardType(
                                                        _vm.billingDetail
                                                          .cardAssociation
                                                      ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                            " +
                                                        _vm._s(
                                                          _vm.formatCardNumber(
                                                            _vm.billingDetail
                                                              .binNumber
                                                          )
                                                        ) +
                                                        "\n                                                        "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color:
                                                        "rgb(160, 160, 160)",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                            " +
                                                        _vm._s(
                                                          _vm.formatCardType(
                                                            _vm.billingDetail
                                                              .cardAssociation
                                                          )
                                                        ) +
                                                        "\n                                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "supsis-ghost-button",
                                  attrs: {
                                    disabled:
                                      _vm.billingDetail &&
                                      !_vm.billingDetail.name,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.updatingCard = true
                                    },
                                  },
                                },
                                [
                                  _vm.billingDetail && _vm.billingDetail.name
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "material-icons",
                                          staticStyle: {
                                            "font-size": "16px",
                                            "margin-right": "5px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                edit\n                                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(
                                        _vm.billingDetail &&
                                          _vm.billingDetail.name
                                          ? _vm.billingDetail &&
                                            _vm.billingDetail.binNumber
                                            ? _vm.$t("message.edit")
                                            : _vm.$t("billing.newPaymentMethod")
                                          : "Fatura Adresini Giriniz!"
                                      ) +
                                      "\n                                        "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.forecastDetails
          ? _c("div", { staticClass: "billing-section" }, [
              _c(
                "div",
                {
                  staticClass: "title-head",
                  on: {
                    click: function ($event) {
                      return _vm.toggleCollopes("futureInvoice")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("billing.futureInvoice"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "collopse" }, [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.collopes["futureInvoice"]
                              ? "arrow_right"
                              : "arrow_drop_down"
                          ) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content",
                  class: { closed: _vm.collopes["futureInvoice"] },
                },
                [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "title" }, [
                      _c("div", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("billing.futureInvoice")) +
                            "\n                            "
                        ),
                        _c("span", { staticStyle: { "font-size": "18px" } }, [
                          _vm._v(
                            "(" + _vm._s(_vm.forecastDetails.invoiceDate) + ")"
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "bills-content" }, [
                      _c("div", { staticClass: "running-invoice" }, [
                        _c("div", { staticClass: "running-invoice-detail" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "running-invoice-detail-title" },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t("billing.invoicePeriod")) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.forecastDetails.dateBetween)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "running-invoice-detail-title" },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t("billing.invoiceStatus")) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.$t("billing.expected"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "running-invoice-detail-title" },
                              [_vm._v(_vm._s(_vm.$t("billing.creationDate")))]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.forecastDetails.leftTime)),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "running-invoice-price-details" },
                          [
                            _c(
                              "div",
                              { staticClass: "running-invoice-price-detail" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "running-invoice-detail-title",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$t(
                                            "billing.monthlyEstimatedAmount"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "price" },
                                  [
                                    _c("MoneyFormatter", {
                                      attrs: {
                                        price:
                                          _vm.forecastDetails
                                            .endOfMonthForecast,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-top": "10px" } },
                                  [
                                    _c(
                                      "SupsisButton",
                                      {
                                        attrs: { ghost: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showForecastDetails(
                                              "endOfMonthForecast"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Detayları Görüntüle\n                                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "running-invoice-price-detail" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "running-invoice-detail-title",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$t("billing.currentAmount")
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "price" },
                                  [
                                    _c("MoneyFormatter", {
                                      attrs: {
                                        price: _vm.forecastDetails.untilToday,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-top": "10px" } },
                                  [
                                    _c(
                                      "SupsisButton",
                                      {
                                        attrs: { ghost: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showForecastDetails(
                                              "untilToday"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Detayları Görüntüle\n                                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.showRunningInvoiceDetails
                        ? _c(
                            "div",
                            {
                              staticClass: "running-invoice-details",
                              class: { closed: !_vm.showRunningInvoiceDetails },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "running-invoice-details-title",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.showRunningInvoiceDetails ===
                                          "untilToday"
                                          ? "Mevcut Tutar Detayları"
                                          : "Ay Sonu Tahmini Detayları"
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.forecastDetails.details,
                                function (plan) {
                                  return _c(
                                    "div",
                                    { staticClass: "detail-content" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "sub-item-detail zebra",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "sub-item-name" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.title[plan.type] ||
                                                      plan.type
                                                        .split("-")
                                                        .map(function (c) {
                                                          return (
                                                            c[0].toUpperCase() +
                                                            c
                                                              .slice(1)
                                                              .toLowerCase()
                                                          )
                                                        })
                                                        .join(" ")
                                                  ) +
                                                  "\n                                        "
                                              ),
                                              _vm.isFeature(plan)
                                                ? _c("span", [
                                                    _vm._v(" (Özellik) "),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "sub-item-price" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  ~~(plan.totalPrice.price || 0)
                                                ) + "₺"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        _vm._l(
                                          Object.values(plan.details),
                                          function (detail) {
                                            return _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "detail-content-child",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "sub-item-detail",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sub-item-child-name",
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                                                    - " +
                                                              _vm._s(
                                                                detail.plan
                                                                  .title
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                detail.plan
                                                                  .altTitle
                                                              ) +
                                                              "\n                                                    " +
                                                              _vm._s(
                                                                detail.plan
                                                                  .type ===
                                                                  "supsis"
                                                                  ? "(" +
                                                                      detail
                                                                        .planAction
                                                                        .details
                                                                        .agentCount +
                                                                      " Agent) " +
                                                                      (_vm.getFreeAgentCount(
                                                                        detail
                                                                          .plan
                                                                          .features
                                                                      )
                                                                        ? "(+" +
                                                                          _vm.getFreeAgentCount(
                                                                            detail
                                                                              .plan
                                                                              .features
                                                                          ) +
                                                                          " Ücretsiz)"
                                                                        : "")
                                                                  : [
                                                                      "whatsapp-business",
                                                                      "whatsapp",
                                                                    ].includes(
                                                                      detail
                                                                        .plan
                                                                        .type
                                                                    )
                                                                  ? "(" +
                                                                    detail
                                                                      .planAction
                                                                      .details
                                                                      .whatsappChannel +
                                                                    " Kanal)"
                                                                  : detail.plan
                                                                      .type ===
                                                                    "instagram"
                                                                  ? "(" +
                                                                    detail
                                                                      .planAction
                                                                      .details
                                                                      .instagramChannel +
                                                                    " Kanal)"
                                                                  : detail.plan
                                                                      .type ===
                                                                    "messenger"
                                                                  ? "(" +
                                                                    detail
                                                                      .planAction
                                                                      .details
                                                                      .messengerChannel +
                                                                    " Kanal)"
                                                                  : ""
                                                              ) +
                                                              "\n                                                "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              detail.plan
                                                                .type ===
                                                                "extra-package"
                                                                ? "(" +
                                                                    detail.sessionCount +
                                                                    " Session)"
                                                                : detail.startDate +
                                                                    " - " +
                                                                    detail.endDate
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sub-item-child-price",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              plan.type ==
                                                                "chatbot"
                                                                ? detail.sessionCount +
                                                                    " Session"
                                                                : (detail.price ||
                                                                    0) > 0
                                                                ? _vm.seperateWithCommas(
                                                                    (
                                                                      detail.price ||
                                                                      0
                                                                    ).toFixed(2)
                                                                  ) + "₺"
                                                                : "0₺"
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "align-items": "flex-end",
                                    "justify-content": "flex-end",
                                    "margin-top": "20px",
                                    gap: "10px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "14px",
                                          },
                                        },
                                        [_vm._v("Toplam Tutar")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "20px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.getPriceDetail().price
                                              ) +
                                              "₺\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "15px",
                                          },
                                        },
                                        [_vm._v("KDV Tutar (%20)")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "20px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.getPriceDetail().kdvPrice
                                              ) +
                                              "₺\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "14px",
                                          },
                                        },
                                        [_vm._v("KDV Dahil Toplam Tutar")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "20px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.getPriceDetail().totalPrice
                                              ) +
                                              "₺\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRunningInvoiceDetails
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "20px",
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "center",
                                cursor: "pointer",
                                "font-size": "18px",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showRunningInvoiceDetails = null
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Hide Details\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "billing-section" }, [
          _c(
            "div",
            {
              staticClass: "title-head",
              on: {
                click: function ($event) {
                  return _vm.toggleCollopes("invoices")
                },
              },
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("billing.pastInvoices"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "collopse" }, [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.collopes["invoices"]
                          ? "arrow_right"
                          : "arrow_drop_down"
                      ) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content",
              class: { closed: _vm.collopes["invoices"] },
            },
            [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "bills-content" }, [
                  _c(
                    "div",
                    { staticClass: "bill-table" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "table-head",
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                            "padding-top": "20px",
                          },
                        },
                        [
                          _c("div", [
                            _vm.isAdmin
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "bill-search",
                                    on: { click: _vm.createBillModal },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("add")]
                                    ),
                                    _vm._v(
                                      "\n                                        Fatura Oluştur\n                                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm._m(1),
                        ]
                      ),
                      _vm._v(" "),
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          "data-source": _vm.invoices,
                          "row-selection": _vm.rowSelection,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "paid",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  record.paid && !record.refund
                                    ? _c("div", {
                                        staticStyle: {
                                          background: "green",
                                          width: "10px",
                                          height: "10px",
                                          "border-radius": "100px",
                                          "margin-right": "5px",
                                        },
                                      })
                                    : record.refund
                                    ? _c("div", {
                                        staticStyle: {
                                          background: "yellow",
                                          width: "10px",
                                          height: "10px",
                                          "border-radius": "100px",
                                          "margin-right": "5px",
                                        },
                                      })
                                    : _c("div", {
                                        staticStyle: {
                                          background: "red",
                                          width: "10px",
                                          height: "10px",
                                          "border-radius": "100px",
                                          "margin-right": "5px",
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          record.paid && !record.refund
                                            ? "" + _vm.$t("billing.paid")
                                            : record.refund
                                            ? "Geri Ödeme Yapıldı"
                                            : "" + _vm.$t("billing.unPaid")
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]
                              )
                            },
                          },
                          {
                            key: "_id",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(record._id.slice(12)) +
                                      "\n                                "
                                  ),
                                ]
                              )
                            },
                          },
                          {
                            key: "price",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("MoneyFormatter", {
                                    attrs: { price: record.price },
                                  }),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "createdDate",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.formatDate(record.createdDate)
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              )
                            },
                          },
                          {
                            key: "isViewing",
                            fn: function (text, record) {
                              return _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  record.pdf
                                    ? _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "margin-right": "10px",
                                            "user-select": "none",
                                            cursor: "pointer",
                                            color: "black",
                                            "text-decoration": "none",
                                          },
                                          attrs: {
                                            href:
                                              "https://static.supsis.live/" +
                                              record.pdf,
                                            target: "”_blank”",
                                            download: record.pdf
                                              .split("/")
                                              .pop(),
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "margin-right": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            download\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        Fatura\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        "margin-right": "10px",
                                        "user-select": "none",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push(
                                            "/billing/invoice/" + record._id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "material-icons",
                                          staticStyle: {
                                            "font-size": "16px",
                                            "margin-right": "5px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            visibility\n                                        "
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                        İncele\n                                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !record.paid
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "margin-right": "10px",
                                            "user-select": "none",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.paymentBill(record._id)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "margin-right": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            paid\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        Hemen Öde\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isAdmin
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "margin-right": "10px",
                                            "user-select": "none",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteInvoice(
                                                record._id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "margin-right": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            delete\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        Sil\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isAdmin && record.paid && !record.refund
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "margin-right": "10px",
                                            "user-select": "none",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.refundInvoice(
                                                record._id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "margin-right": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            payments\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        Geri Öde\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isAdmin && !record.paid && !record.refund
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "user-select": "none",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.markPaidBill(
                                                record._id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "margin-right": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            payments\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        Ödendi\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isAdmin
                                    ? _c(
                                        "a-popconfirm",
                                        {
                                          attrs: {
                                            placement: "bottomRight",
                                            "ok-text": "Onayla",
                                            cancelText: "İptal",
                                          },
                                          on: {
                                            confirm: function ($event) {
                                              return _vm.updateInvoicePrice(
                                                record
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            staticStyle: { display: "none" },
                                            attrs: {
                                              slot: "icon",
                                              type: "question-circle-o",
                                            },
                                            slot: "icon",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "template",
                                            { slot: "title" },
                                            [
                                              _c("a-input-number", {
                                                model: {
                                                  value: _vm.invoicePrice,
                                                  callback: function ($$v) {
                                                    _vm.invoicePrice = $$v
                                                  },
                                                  expression: "invoicePrice",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "user-select": "none",
                                                cursor: "pointer",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    "margin-right": "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                payments\n                                            "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                                            Fiyat Düzenle\n                                        "
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("lightbulb")]),
      _vm._v(
        "\n                Şuan deneme sürümündesiniz. Ayrıcalıklı paketleri görmek için deneme sürümünü hemen\n                atlayabilirsiniz.\n            "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" download ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }